import {TemplateState, TemplateActionTypes} from './types';

import {themes} from './constants';

const initialState: TemplateState = {
  themes,
};

export default function templateReducer(
  state = initialState,
  action: TemplateActionTypes
): TemplateState {
  switch (action.type) {
    default:
      return state;
  }
}
